// Importing actions to set and unset starred coins from Redux
import { setStarredCoin, unsetStarredCoin } from '../redux/actions/coinsAction';

// Function to handle starring/unstarring a coin
const starredCoin = (coin, dispatch) => {
    // Retrieve starred coins from localStorage
    let starredCoins = localStorage.getItem("starred_coins");

    if (!starredCoins) {
        // If no starred coins, initialize with the current coin's ID
        localStorage.setItem("starred_coins", JSON.stringify([coin.id]));
    } else {
        // Parse existing starred coins
        starredCoins = JSON.parse(starredCoins);

        if (starredCoins.includes(coin.id)) {
            // If coin is already starred, remove it
            starredCoins = starredCoins.filter((elem) => elem !== coin.id);
            localStorage.setItem("starred_coins", JSON.stringify([...starredCoins]));

            // Dispatch action to unset the starred coin in Redux store
            dispatch(unsetStarredCoin(coin.id));
        } else {
            // If coin is not starred, add it
            localStorage.setItem("starred_coins", JSON.stringify([...starredCoins, coin.id]));

            // Dispatch action to set the starred coin in Redux store
            dispatch(setStarredCoin(coin.id));
        }
    }
};

// Exporting the starredCoin function
export default starredCoin;
